export default "__VITE_ASSET__DntcBY1s__"